<template>
  <div>
    <div class="overlay-sub" :class="[reel_drawer ? 'overlay open' : 'overlay']" @click="closeDrawer()"></div>
    <div class="media-detail-modal" :class="[reel_drawer ? 'open' : '']">
      <div class="detail-modal" v-if="post_data">
        <div class="detail-profile-wrap">
          <div class="detail-profile-img-area">
            <a :href="'https://instagram.com/' + profile_data.account_name + '/'" target="_blank">
              <el-image class="detail-profile_img" :src="search_type == 'request_pr' ? post_data.profile_picture_url : profile_data.profile_picture_url">
                <div slot="error" class="data-table-profile-noimg">
                  NO
                  <br />IMAGE
                </div>
              </el-image>
            </a>
          </div>
          <div class="detail-profile-name-area">
            <div class="detail-profile-name">{{ profile_data.account_name }}</div>
            <div class="detail-sponsor" v-show="post_data.sponsor">
              <span>{{ post_data.sponsor }}</span>とのタイアップ投稿
            </div>
            <div class="detail-location" v-show="post_data.location">
              <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="margin-right: 3px;" />
              {{ post_data.location }}
            </div>
          </div>
        </div>
        <div class="detail-img-wrap">
          <div class="detail-img-area">
            
            <!-- コストの関係でリールについては動画ではなくサムネイル表示とする -->            
            <!-- <video  class="detail-img" :src="s3BaseUrl + '/reel/' + post_data.ig_id + '/' + post_data.media_id + '/video.mp4'" muted loop controls alt=""></video> -->
            
            <el-image :src="post_data.img_url+'?'+actionId" class="detail-img" v-show="!detail_loading" @load="imgDetailLoaded()">
              <div slot="error" class="detail-img error">
                <font-awesome-icon icon="exclamation-circle" />
              </div>
            </el-image>
            
            <div class="pr_type" v-show="post_data.pr_flag">
              <div class="pr_tag">PR</div>
            </div>
            <div class="media_type" v-show="post_data.media_type == 'GraphVideo' && (post_data.s3_url == 'feed' || post_data.s3_url == null) && !detail_loading">
              <font-awesome-icon :icon="['far', 'play']" class="media_tag" />
            </div>
            <div class="media_type" v-show="post_data.media_type == 'GraphVideo' && post_data.s3_url == 'clips' && !detail_loading">
              <div class="media_tag">
                <img src="../../../assets/reels.png" class="media_type-reels w-14" alt />
              </div>
            </div>
            <div class="media_type" v-show="post_data.media_type == 'GraphSidecar' && !detail_loading">
              <font-awesome-icon :icon="['far', 'clone']" class="media_tag" />
            </div>
            <div class="detail-img-load" v-show="detail_loading"></div>
          </div>
          <div class="detail-tagged-user-area" v-show="!detail_loading">
            <div class="tagged-user-icon-wrap">
              <div class="tagged-user-icon" v-show="post_data.tagged_user_1" @click="tagged_show()">
                <font-awesome-icon icon="user-friends" />
              </div>
            </div>
            <transition name="fade">
              <div class="tagged-user-wrap" v-show="tagged_user">
                <div class="tagged-user" v-show="post_data.tagged_user_1">{{ post_data.tagged_user_1 }}</div>
                <div class="tagged-user" v-show="post_data.tagged_user_2">{{ post_data.tagged_user_2 }}</div>
                <div class="tagged-user" v-show="post_data.tagged_user_3">{{ post_data.tagged_user_3 }}</div>
                <div class="tagged-user" v-show="post_data.tagged_user_4">{{ post_data.tagged_user_4 }}</div>
                <div class="tagged-user" v-show="post_data.tagged_user_5">{{ post_data.tagged_user_5 }}</div>
              </div>
            </transition>
          </div>
        </div>
        <div class="detail-engage-area">
          <div class="detail-engage-box">
            <font-awesome-icon :icon="['far', 'play']" style="margin-left:6px; font-size:12px" />
            {{ post_data.video_play_count }}
            <font-awesome-icon :icon="['fal', 'heart']" style="margin-left:6px; font-size:12px" />
            {{ post_data.like_count > 0 ? post_data.like_count : '非表示' }}
            <font-awesome-icon :icon="['fal', 'comment']" style="margin-left:6px; font-size:12px" />
            {{ post_data.comments_count }}
            <span style="margin-left:6px; font-size:12px">EGR</span>
            {{ post_data.egr }}%
          </div>
          <div class="detail-link">
            <a :href="'https://www.instagram.com/p/' + post_data.shortcode + '/'" target="_blank">
              <el-button type="info" size="mini" style="margin-left:10px;">Instagram→</el-button>
            </a>
          </div>
        </div>
        <div class="detail-caption-area">
          <pre
            class="caption-in"
            v-html="$options.filters.searchHighlight(post_data.caption, (search_type == 'keyword' || search_type=='hashtag' || search_type == 'gender_check' ? search_keyword : ''), search_type == 'pr' || search_type == 'request_pr' ? true : false)"
          ></pre>
          <div class="detail-date">{{ post_data.timestamp }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reel_drawer", "profile_data", "post_data", "search_type", "search_keyword", "pr_word"],
  name: "reelDetail",
  data() {
    return {
      detail_loading: true,
      tagged_user:false,
      actionId: Math.floor( new Date().getTime() / 1000 ),
      // s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  methods: {
    imgDetailLoaded() {
      this.detail_loading = false;
    },
    closeDrawer(){
      this.detail_loading = true
      this.actionId += 1
      this.$emit("closeDrawer", 'reel')
    },
    tagged_show() {
      this.tagged_user = !this.tagged_user;
    },
  },
  filters: {
    searchHighlight(value, keyword, pr) {
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else if (pr == true) {
        if (this.search_type == "pr") {
          var pr_regexp = this.pr_word;
        } 
        const keyword_RegExp = new RegExp(pr_regexp, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else {
        return value;
      }
    },
  },
};
</script>

<style></style>
